export default function() {
  'ngInject';

  function statusText(status) {
    if (status === 'reviewed') return 'Reviewed';
    if (status === 'redeemed') return 'Completed';
    if (status === 'completed') return 'Completed';
    if (status === 'attended') return 'Attended';
    if (status === 'invitation') return 'Invited';
    if (status === 'waitlisted') return 'Waitlisted';
    return 'Registered';
  }

  function statusClasses(text) {
    if (text === 'Reviewed') return 'label-info badge-info';
    if (text === 'Registered') return 'label-success badge-success';
    if (text === 'Completed') return 'label-primary badge-primary';
    if (text === 'Attended') return 'label-basic badge-basic';
    if (text === 'Waitlisted') return 'label-warning badge-warning';
    if (text === 'Invited') return 'label-warning badge-warning';
  }

  return {
    restrict: 'A',
    scope: {
      status: '<'
    },
    link: function(scope, element) {
      const text = statusText(scope.status);
      const color = statusClasses(text);
      element.addClass(color);
      element.html(text);
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/eventStatusLabel/index.js